import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
};

const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
  },
});

export const { setUser, clearUser } = userDataSlice.actions;
export default userDataSlice.reducer;
